import { ManualProduct } from "Store/interfaces/products/checkout/ManualProduct";
import { isDefined } from "Utils/functions";
import { ProductDetail } from "../../interface";
export const manualProductDetailsList = (
  product: ManualProduct,
): ProductDetail[] => {
  if (isDefined(product.customFields)) {
    return product.customFields.map((customField) => ({
      name: customField.label,
      value: customField.value,
    }));
  }
  return [];
};
